import React from 'react';

import { ModalFullscreen } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IFullScreenGalleryProps {
  header: React.ReactNode;
  content: React.ReactNode;
  onClose(): void;
}

export function FullScreenGallery({ header, content, onClose }: IFullScreenGalleryProps) {
  const stopPointerPropagation = (event: React.PointerEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <ModalFullscreen open escape onClose={onClose} theme="white" portal>
      <div
        className={styles['container']}
        onPointerDown={stopPointerPropagation}
        onPointerMove={stopPointerPropagation}
        onPointerUp={stopPointerPropagation}
        onPointerCancel={stopPointerPropagation}
      >
        <div>{header}</div>
        <div>{content}</div>
      </div>
    </ModalFullscreen>
  );
}
